<template>
  <BaseModal
    :value="true"
    @input="$emit('close')"
    title="Add Notes to Multiple Applications"
  >
    <div class="bulk-notes-modal-content">
      <p class="mb-4">
        Add notes to <strong>{{ count }}</strong> selected application(s)
      </p>
      <textarea
        v-model="notes"
        rows="6"
        class="regular full bordered"
        placeholder="Enter notes for all selected applications..."
      ></textarea>
      <div class="modal-actions">
        <button @click="save" class="btn-success-button">
          Save to {{ count }} Applications
        </button>
        <button @click="$emit('close')" class="btn-dark-button">Cancel</button>
      </div>
    </div>
  </BaseModal>
</template>

<script>
export default {
  name: "BulkNotesModal",
  props: {
    count: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      notes: ""
    };
  },
  methods: {
    save() {
      if (!this.notes.trim()) {
        this.$toast.error("Please enter notes");
        return;
      }
      this.$emit("save", this.notes);
    }
  }
};
</script>

<style lang="scss" scoped>
.bulk-notes-modal-content {
  padding: 1rem;
}

.modal-actions {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  margin-top: 1rem;
}
</style>
